import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";

const filterInputs = {
    invoice_no:'',
    installment_status: null,
    billing_type: null,
    ti_number: '',
    site_number: '',
    client_name: '',
    from_pi_date: '',
    to_pi_date: '',
};

const statusOptions = [
    {id: 'PENDING', name: 'PENDING'},
    {id: 'SYSTEM_APPROVED', name: 'SYSTEM_APPROVED'},
    {id: 'FUSION_APPROVED', name: 'FUSION_APPROVED'},
    {id: 'REJECTED', name: 'REJECTED'}
];

const billingOptions = [
    {id: '1', name: 'Prepaid'},
    {id: '2', name: 'Postpaid'},
];

const optionName = (options, id) =>
    options.find((item) => String(item.id) === String(id))?.name || "";

const Filters = ({
                     showFilter = false,
                     filterToggle,
                     applyFilter,
                     appliedFilterValues = null,
                 }) => {
    const [filterFieldsData, setFilterFieldsData] = useState({
        ...filterInputs,
        ...(appliedFilterValues || {}),
    });

    const [isFocus, setIsFocus] = useState(Boolean(appliedFilterValues?.from_pi_date));
    const [isFocus2, setIsFocus2] = useState(Boolean(appliedFilterValues?.to_pi_date));

    useEffect(() => {
        if (!appliedFilterValues) return;
        setFilterFieldsData({
            ...filterInputs,
            ...appliedFilterValues,
        });
        setIsFocus(Boolean(appliedFilterValues.from_pi_date));
        setIsFocus2(Boolean(appliedFilterValues.to_pi_date));
    }, [appliedFilterValues]);

    const handleDateHide = () => {
        if (!filterFieldsData.from_pi_date) {
          setIsFocus(true);
        }
      };
    const handleDateHide2 = () => {
        if (!filterFieldsData.to_pi_date) {
        setIsFocus2(true);
        }
    };

    const handleDateChange = (jsdate, dateString) => {
        setFilterFieldsData({
          ...filterFieldsData,
          from_pi_date: dateString,
        });
      };
      const handleDateChange2 = (jsdate, dateString) => {
        setFilterFieldsData({
          ...filterFieldsData,
          to_pi_date: dateString,
        });
      };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                if (!appliedFilterValues && filterFieldsData) {
                    localStorage.setItem("valet_invoice_b2b", JSON.stringify(filterFieldsData));
                }
            }}
        >
            <div className={showFilter ? "show-filter" : ""}>
                {showFilter && (
                    <div className="filter-wrapper">
                        <div className="filter-heading">
                            <h4>Filters</h4>
                            <Button onClick={filterToggle} className="close">
                                <i className="close"></i>
                            </Button>
                        </div>
                        <div className="filter-body scrollbar-styling">
                            <ConstantInput
                                label={'PI Number'}
                                value={filterFieldsData.invoice_no || ""}
                                handleChange={(val) => {
                                    setFilterFieldsData({ ...filterFieldsData, invoice_no: val });
                                }}
                            />
                            <ConstantInput
                                label={'Site Number'}
                                value={filterFieldsData.site_number || ""}
                                handleChange={(val) => {
                                    setFilterFieldsData({ ...filterFieldsData, site_number: val });
                                }}
                            />
                            <ConstantInput
                                label={'Client Name'}
                                value={filterFieldsData.client_name || ""}
                                handleChange={(val) => {
                                    setFilterFieldsData({ ...filterFieldsData, client_name: val });
                                }}
                            />
                            <ConstantInput
                                label={'TI Number'}
                                value={filterFieldsData.ti_number || ""}
                                handleChange={(val) => {
                                    setFilterFieldsData({ ...filterFieldsData, ti_number: val });
                                }}
                            />
                            <DropDownInput
                                data={statusOptions}
                                label={'Status'}
                                value={optionName(statusOptions, filterFieldsData.installment_status)}
                                getIdValue={(val) => {
                                    setFilterFieldsData({
                                        ...filterFieldsData, 
                                        installment_status: val.id 
                                    });
                                }}
                            />

                            <DropDownInput
                                data={billingOptions}
                                label={'Type'}
                                value={optionName(billingOptions, filterFieldsData.billing_type)}
                                getIdValue={(val) => {
                                    setFilterFieldsData({
                                        ...filterFieldsData, 
                                        billing_type: val.id 
                                    });
                                }}
                            />

                            <fieldset>
                                    <h4>PI Date</h4>
                                    <FormGroup
                                      className={`date custom_date_picker ${isFocus ? "active-date" : ""}`}
                                    >
                                      <DatePickerInput
                                        onChange={handleDateChange}
                                        value={filterFieldsData.from_pi_date}
                                        autoClose
                                        onShow={() => setIsFocus(true)}
                                        onHide={handleDateHide}
                                        closeOnClickOutside
                                        showOnInputClick
                                        locale="en"
                                        className="my-custom-datepicker-component"
                                        displayFormat="YYYY-MM-DD"
                                        returnFormat="YYYY-MM-DD"
                                      // maxDate={new Date()}
                                      />
                                      <label>{localization.fromDate}</label>
                                    </FormGroup>

                                    <FormGroup
                                      className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
                                    >
                                      <DatePickerInput
                                        onChange={handleDateChange2}
                                        value={filterFieldsData.to_pi_date}
                                        autoClose
                                        onShow={() => setIsFocus2(true)}
                                        onHide={handleDateHide2}
                                        closeOnClickOutside
                                        showOnInputClick
                                        locale="en"
                                        className="my-custom-datepicker-component"
                                        displayFormat="YYYY-MM-DD"
                                        returnFormat="YYYY-MM-DD"
                                      // maxDate={new Date()}
                                      />
                                      <label>{localization.toDate}</label>
                                    </FormGroup>
                            </fieldset>

                            <div className="btn-wrapper">
                                <button
                                    disabled={false}
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    {localization.applyFilter}
                                </button>
                                <br />
                                <br />
                                <button
                                    onClick={() => {
                                        if (!appliedFilterValues) {
                                            localStorage.setItem(
                                                "applyFilter",
                                                JSON.stringify(filterInputs)
                                            );
                                            localStorage.setItem("valet_invoice_b2b", JSON.stringify({}));
                                        }
                                        setFilterFieldsData({ ...filterInputs });
                                        setIsFocus(false);
                                        setIsFocus2(false);
                                        applyFilter({ ...filterInputs });
                                    }}
                                    type="button"
                                    className="btn btn-primary"
                                >
                                    {localization.removeFilter}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </form>
    );
};

export default Filters;
